import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { BannerModule, ButtonV3Component, CheckboxV2Module, CheckboxV3Component, ChipV3Component, IconV3Component, InputV3Component, ModalV2Module, PageHeaderModule, PageLayoutModule, PageLayoutV3Component, ProgressSpinnerComponent, SelectV2Module, SidebarV3Component, SnackbarModule, SnackbarV3Component, TabMenuV2Module, TabMenuV3Component, WizardV2Module } from '@gea/digital-ui-lib';

@NgModule({
  declarations: [],
  imports: [
    CommonModule,
    ButtonV3Component,
    TabMenuV2Module,
    PageHeaderModule,
    WizardV2Module,
    ModalV2Module,
    InputV3Component,
    SnackbarV3Component,
    SelectV2Module,
    CheckboxV2Module,
    IconV3Component,
    CheckboxV3Component,
    ChipV3Component,
    TabMenuV3Component,
    PageLayoutV3Component,
    PageLayoutModule,
    SidebarV3Component,
    ProgressSpinnerComponent
  ],
  exports: [
    ButtonV3Component,
    TabMenuV2Module,
    PageHeaderModule,
    SnackbarV3Component,
    WizardV2Module,
    ModalV2Module,
    InputV3Component,
    SelectV2Module,
    CheckboxV2Module,
    IconV3Component,
    CheckboxV3Component,
    ChipV3Component,
    TabMenuV3Component,
    PageLayoutV3Component,
    PageLayoutModule,
    SidebarV3Component,
    ProgressSpinnerComponent
  ]
})
export class GeaLibraryModule { }
